import { YardBlockOption } from '../design-system';

export enum AccountStatus {
  ACTIVE = 'ACTIVATE',
  DEACTIVATED = 'DEACTIVATE',
}

export enum BelongsTo {
  SUPER_ADMIN = 'SUPER_ADMIN',
  YARD_COMPANY = 'YARD_COMPANY',
  YARD = 'YARD',
  CLIENT = 'CLIENT',
}

type UserType =
  | 'YARD_COMPANY_ADMIN'
  | 'YARD_COMPANY_EMPLOYEE'
  | 'YARD_MANAGER'
  | 'YARD_DISPATCHER'
  | 'YARD_CRANE_OPERATOR'
  | 'CLIENT_MANAGER'
  | 'CLIENT_DISPATCHER';

export type UserTypeAll = 'SUPER_ADMIN' | UserType;

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  accountStatus: AccountStatus;
  belongsTo: BelongsTo;
  yardCompanyEmployee: YardCompanyEmployee;
  yardEmployee: YardEmployee;
  clientEmployee: ClientEmployee;
  createdAt: Date;
  updatedAt: Date;
  type: UserType & any;
}

export interface ImageObjType {
  action: 'upload' | 'delete';
  file: any;
  name?: string;
}

export type ContainerType = '20DC' | '20HC' | '40DC' | '40HC' | '45HC';

export interface UserVisitGetAllQuery {
  data: {
    user: {
      firstName: string;
      lastName: string;
      email: string;
    };
    createdAt: string;
    lastVisitedAt: string;
    ip: string;
    country: string;
    countryCode: any;
    deviceName: string;
    role: string;
    clientCode: string;
    status: 'ONLINE' | 'OFFLINE';
  }[];
  totalCount: number;
}

export interface YardGetBlocksQuery {
  data: YardBlockOption[];
}

interface YardCompanyEmployee {
  yardCompanyId: string;
  role: string;
  yardCompany: { legalName: string };
}

interface YardEmployee {
  yardId: string;
  role: string;
  yard: { name: string };
}

interface ClientEmployee {
  clientId: string;
  role: string;
  client: { legalName: string };
}

export interface InventoryGetAllQuery {
  data: {
    id: string;
    yardName: string;
    createdAt: string;
  }[];
  totalCount: number;
}

export interface InventoryGetItemsQuery {
  data: {
    containerId: string;
    number: string;
    status: 'FOUND' | 'EXTRA_FOUND' | 'NOT_FOUND';
    unchecked: {
      type: string;
      block: string;
      row?: number;
    };
    checked?: {
      type: string;
      block: string;
      row?: number;
    };
  }[];
}

export type CurrencyCode = 'USD' | 'EUR' | 'RUB' | 'UZS' | 'TRY' | 'KZT';

export interface CurrencyGetAllResponse {
  data: {
    code: CurrencyCode;
    unitsPerUSD: number;
  }[];
}

export type RepairStatus = 'DRAFT' | 'PENDING' | 'ACTIVE' | 'REJECTED' | 'COMPLETED';

export interface RepairCreateProps {
  id: string;
  description: string;
}

export interface RepairGetAllQuery {
  data: {
    id: string;
    invoiceLineId?: string;
    status: RepairStatus;
    price: number;
    currencyCode: CurrencyCode;
    description: string;
    expectedDurationDays: number;
    beforeImages: { url: string; name: string }[];
    afterImages: { url: string; name: string }[];
    createdAt: string;
    acceptedAt: string;
    container: {
      number: string;
      clientYard: {
        client: {
          code: string;
        };
      };
    };
    completedByName: string;
  }[];
  totalCount: number;
}

export interface RepairGetAllGroupQuery {
  data: {
    clientYard: {
      client: {
        code: string;
      };
    };
    id: string;
    number: string;
    createdAt: string;
    images: {
      url: string;
    }[];
    repair: {
      invoiceLineId?: string;
      price: number;
      currencyCode: CurrencyCode;
      status: RepairStatus;
    }[];
    customRepair: {
      price: string;
      pendingCount: number;
      activeCount: number;
      uncreatedInvoiceCount: number;
    };
  }[];
  totalCount: number;
}

export interface RepairUpdateProps {
  id: string;
  price: number;
  currencyCode: CurrencyCode;
  expectedDurationDays: number;
  description: string;
}

export interface RepairUpdateImagesProps {
  id: string;
  photos: ImageObjType[];
  action: 'before' | 'after';
}

export interface IdProps {
  id: string;
}
